<template>
  <v-container class="pa-0">
    <v-speed-dial v-model="fabMenu" bottom right fixed direction="top">
      <template v-slot:activator>
        <v-btn v-model="fabMenu" color="secondary" dark fab>
          <v-icon v-if="fabMenu">{{ mdiClose }} </v-icon>
          <v-icon v-else>{{ mdiDotsVertical }} </v-icon>
        </v-btn>
      </template>
      <div class="fab">
        <v-chip
          class="fab-label"
          color="indigo"
          text-color="white"
          @click="toBottom()"
          v-if="showlabel"
        >
          {{ $t("label.sitemap") }}
        </v-chip>
        <v-btn fab dark small color="indigo" @click="toBottom()">
          <v-icon>{{ mdiPageLayoutFooter }}</v-icon>
        </v-btn>
      </div>

      <div class="fab">
        <v-chip
          class="fab-label"
          color="green"
          text-color="white"
          @click="toTutorial()"
          v-if="showlabel"
        >
          {{ $t("label.tutorial") }}
        </v-chip>
        <v-btn fab dark small color="green" @click="toTutorial()">
          <v-icon>{{ mdiSchool }}</v-icon>
        </v-btn>
      </div>

      <div class="fab">
        <v-chip
          class="fab-label"
          color="red"
          text-color="white"
          @click="toHomeSection('ProhibitedGoods')"
          v-if="showlabel"
        >
          {{ $t("label.prohibited_goods") }}
        </v-chip>
        <v-btn
          fab
          dark
          small
          color="red"
          @click="toHomeSection('ProhibitedGoods')"
        >
          <v-icon>{{ mdiCancel }}</v-icon>
        </v-btn>
      </div>
      <div class="fab">
        <v-btn fab dark small color="blue" @click="toTop()">
          <v-icon>{{ mdiArrowUpBold }}</v-icon>
        </v-btn>
      </div>
    </v-speed-dial>
  </v-container>
</template>

<script>
import {
  mdiArrowUpBold,
  mdiArrowDownBold,
  mdiSchool,
  mdiPageLayoutFooter,
  mdiCancel,
  mdiDotsVertical,
  mdiClose,
} from "@mdi/js";

export default {
  props: {
    menuOptions: {
      type: Array,
    },
  },
  data: () => ({
    fabMenu: false,
    showlabel: true,

    //svg icons
    mdiArrowUpBold,
    mdiArrowDownBold,
    mdiSchool,
    mdiPageLayoutFooter,
    mdiCancel,
    mdiDotsVertical,
    mdiClose,
  }),
  mounted() {},
  computed: {
    pageHeight() {
      return document.body.scrollHeight;
    },
  },
  methods: {
    toTop() {
      this.$vuetify.goTo(0);
    },
    toBottom() {
      this.$vuetify.goTo(this.pageHeight);
    },
    toTutorial() {
      this.$router.push({ name: "tutorial" }).catch(() => {});
    },
    toHomeSection(section) {
      console.log(section);
      const el = this.$parent.$el.querySelector(`#${section}`);
      if (el) {
        window.location.hash = section;
        el.scrollIntoView({ behavior: "smooth" });
      } else {
        console.log(window.location);
        this.$router.push({ path: `/#${section}` }).catch(() => {
          this.toSection();
        });
      }
    },
    toSection(section) {
      var element = document.getElementById(section);
      if (element != null) {
        element.scrollIntoView();
      }
    },
  },
};
</script>

<style scoped>
.fab {
  position: relative;
  padding-left: 200px;
  padding-right: 200px;
}
.fab-label {
  position: absolute;
  top: 11px;
  right: 250px;
}
</style>
